/* eslint-disable camelcase */

const getVirtualValueMessage = (isGECardHolder, hasOffers, rewardAmount) => {
  // Default to '!GE, no Offer'
  const virtualValueMessage = "NG_0_NO";
  if (isGECardHolder) {
    if (hasOffers) {
      // GE, reward dollars, Offer
      return `GE_${rewardAmount}_OFR`;
    }
    // GE, reward dollars, no Offer
    return `GE_${rewardAmount}_NO`;
  }
  if (hasOffers) {
    //! GE, no reward, Offer
    return "NG_0_OFR";
  }

  return virtualValueMessage;
};

const getMsg = ({
  GECardHolder,
  totalRewardValue = "0",
  hasOffers = "false",
}) => {
  const isGECardHolder = GECardHolder === "true" || false;
  const rewardAmount = parseFloat(totalRewardValue);

  const virtualValueMessage = getVirtualValueMessage(
    isGECardHolder,
    hasOffers,
    rewardAmount
  );

  return {virtual_value_message: virtualValueMessage};
};

const getCustomerType = (userContext) => {
  const {isLoggedInUser, isRecognizedUser} = userContext;
  return isLoggedInUser === "true" || isRecognizedUser === "true"
    ? "existing"
    : "new";
};

const getRecognitionStatus = (userContext) => {
  const {isLoggedInUser, isRecognizedUser} = userContext;
  if (isLoggedInUser === "true") {
    return "authenticated";
  }
  if (isRecognizedUser === "true") {
    return "recognized";
  }
  return "unrecognized";
};

const personalizedPreferenceRegex = /^[AT|ON|GAP|GP|BR]*[US|CA|JP|UK|EU]*(DIV|CAT)PREF[_pref\d]*$/;
const personalizedKeysMap = {
  CARDSTATUS: "cardholder_status",
  DS: "discount_sensitivity",
  EMAILUS: "email_status",
};
const getPersonalizeKey = (key) =>
  key.match(personalizedPreferenceRegex)
    ? key.replace(personalizedPreferenceRegex, (match, p1) =>
        p1 === "DIV" ? "division_preference" : "category_preference"
      )
    : personalizedKeysMap[key];

const extractCustomerInfo = (personalizedAttributes = []) => {
  const attributes =
    personalizedAttributes && Array.isArray(personalizedAttributes)
      ? personalizedAttributes
      : [personalizedAttributes];
  return attributes.reduce((data, attr) => {
    const key = getPersonalizeKey(attr.AttributeName);
    if (key) {
      const existingValue = data[key] || "";
      /* eslint-disable-next-line */
      data[key] = existingValue
        ? `${existingValue},${attr.AttributeValue}`
        : attr.AttributeValue;
    }
    return data;
  }, {});
};

const mapPersonalizationData = (personalizationData = {}) => {
  const {
    featureSelections = {},
    userContext = {},
    customerAttributes = {},
  } = personalizationData;
  const {
    cardholder_status,
    division_preference,
    discount_sensitivity,
    category_preference,
    email_status,
  } = extractCustomerInfo((featureSelections || {}).Evergreens);

  const {
    localeCode = "",
    preferredLocaleCode = "",
    userEmailEncrypt: encrypted_customer_email = "",
    userEmailMMEncrypt: encrypted_customer_email_mm = "",
    billingAddressEncrypt: encrypted_billing_address = "",
    clickStream = {},
    globalShippingCountryCode = "",
    globalShippingCurrencyCode = "",
    userEmailEncrypt256 = "",
  } = userContext;

  const languageCode = localeCode || preferredLocaleCode;
  const {
    cipher: encryption_cipher = "",
    vector: encryption_vector = "",
  } = clickStream;
  const {virtual_value_message} = getMsg(customerAttributes || {});
  const customerType = getCustomerType(userContext);
  const recognitionStatus = getRecognitionStatus(userContext);

  return {
    currency_code: globalShippingCurrencyCode,
    country_code: globalShippingCountryCode,
    shipping_country_code: globalShippingCountryCode,
    cardholder_status,
    division_preference,
    discount_sensitivity,
    category_preference,
    email_status,
    encrypted_customer_email,
    encrypted_customer_email_mm,
    encrypted_billing_address,
    hashed_customer_email: userEmailEncrypt256,
    encryption_cipher,
    encryption_vector,
    language_code: languageCode,
    virtual_value_message,
    customer_type: customerType,
    recognition_status: recognitionStatus,
  };
};
// this is for Personalization Team
// this allows Tealium extensions to access Personalization data to generate badges
const exposeDataToWindow = (data) => {
  window.personalizationData = data;
  return data;
};
export default ({datalayer, dataPromise}) => {
  datalayer.add({
    name: "personalization",
    data: dataPromise
      .then(exposeDataToWindow)
      .then(mapPersonalizationData)
      .catch((e) => ({
        error_message: `[Personalization Layer] error building: ${e.message}`,
      })),
  });
};
